import styled from 'styled-components';

const Section = styled.div<{ $isLast?: boolean }>`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background-color: #fff;
  ${({ $isLast }) => $isLast && 'padding-bottom: 72px'};
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const SectionTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;

const Guide = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  background: #f7f8fc;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const SearchButton = styled.button`
  border: none;
  outline: none;

  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #008aff;

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const GraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const GraphWrapper = styled.div`
  width: 100%;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
`;

const DataColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
`;

const DataItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const LegendColor = styled.span<{ $bg: string }>`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: ${({ $bg }) => $bg};
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
`;

const ItemLabel = styled.div<{ $extra?: boolean }>`
  color: #616161;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
  width: 100px;

  ${({ $extra }) => $extra && 'text-align: center;'}
`;

const ItemValue = styled.div<{ $extra?: boolean }>`
  align-self: stretch;
  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;

  ${({ $extra }) => $extra && 'text-align: center;'}
`;

export const s = {
  Section,
  SectionHeader,
  TitleBox,
  SectionTitle,
  Guide,
  SearchButton,
  GraphContainer,
  GraphWrapper,
  DataColumn,
  DataItem,
  LegendColor,
  ItemContent,
  ItemLabel,
  ItemValue,
};
